import userInformationSection from "../../components/userInformationSection/index.vue";

export default {
  name: "userInformation",
  components: {
    userInformationSection,
  },
};
